import React from 'react';
import useDashboardTranslation from '../../../../../../dashboard-translation/hooks/dashboard-translation-hook';
import './exchange-locations-settings-info-section.scss';
import FontBody2 from '../../../../../../components/fonts/font-body2/font-body2';
import {FONT_COLOR, FONT_VARIANT} from "../../../../../../components/fonts/font-props";
import {Note, NOTE_TYPE} from "../../../../../../components/note/note";
import ControlGroup from '../../../../../../components/layouts/control-group/control-group';


const ExchangeLocationsSettingsInfoSection: React.FC = () => {

    const {getTranslation} = useDashboardTranslation();
    const pageScope = 'dashboard-settings-store';

    const exchangeInventorySettingsText = getTranslation('EXCHANGE_INVENTORY_SETTINGS', pageScope);
    const exchangeInventorySettingsNoteText = getTranslation('EXCHANGE_INVENTORY_SETTINGS_NOTE', pageScope);
    const exchangeInventorySettingsInfoText = getTranslation('EXCHANGE_INVENTORY_SETTINGS_INFO', pageScope);

    return (
        <div className="exchange-locations-heading">
            <FontBody2 variant={FONT_VARIANT.BOLD} color={FONT_COLOR.PRIMARY2}>
                {exchangeInventorySettingsText}
            </FontBody2>
            <FontBody2 color={FONT_COLOR.NEUTRAL3}>
                {exchangeInventorySettingsNoteText}
            </FontBody2>
            <ControlGroup>
                <Note
                    type={NOTE_TYPE.INFORMATION}
                    body={
                        <FontBody2>
                            {exchangeInventorySettingsInfoText}
                        </FontBody2>
                    }
                />
            </ControlGroup>
        </div>
    );
};

export default ExchangeLocationsSettingsInfoSection;

